import React from 'react';
import { Link } from 'react-router-dom';
import { FiShield, FiPackage, FiLock, FiKey, FiMail, FiAlertTriangle, FiUserX } from 'react-icons/fi';
import { Trans } from 'react-i18next';
import { CampoSelect, CampoTexto } from './CamposFormulario';
import AsignadorServicios from './AsignadorServicios';
import { useTranslation } from 'react-i18next';
import { ROL_LABELS, DEPTO_LABELS, esStaff } from '../../../../constants/usuarios';

/** Permisos, servicios y seguridad. Solo para administradores. */
const FormularioAjustes = ({
  form, onCampo,
  catalogoServicios, serviciosAsignados, onAlternarServicio, cargandoServicios,
  reseteando, onResetearContrasena,
  onDarDeBaja, puedeDarDeBaja = false,
  esAdmin = true,
}) => {
  const { t } = useTranslation();
  const cambiar = (e) => onCampo(e.target.name, e.target.value);

  // Aviso en el propio campo: los correos mal escritos se descartarían al
  // enviar, así que se marcan mientras se escriben.
  const correosInvalidos = (form.emails_cc || '')
    .split(',')
    .map((correo) => correo.trim())
    .filter((correo) => correo !== '' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(correo));

  const errorCorreosCc = correosInvalidos.length > 0
    ? t('perfilUsuario.correosCopiaInvalidos', { correos: correosInvalidos.join(', ') })
    : undefined;

  return (
    <>
      {esAdmin && (
        <section className="pu-form-bloque">
          <h4 className="pu-form-seccion"><FiShield /> {t('perfilUsuario.permisos')}</h4>

          <div className="pu-form-grid">
            <CampoSelect id="campo-rol" name="role" label={t('perfilUsuario.rol')} value={form.role} onChange={cambiar}>
              {Object.entries(ROL_LABELS).reverse().map(([valor, label]) => (
                <option key={valor} value={valor}>{label}</option>
              ))}
            </CampoSelect>

            {esStaff(form.role) && (
              <CampoSelect
                id="campo-dpto"
                name="dpto_tecnico"
                label={t('perfilUsuario.departamentoTecnico')}
                value={form.dpto_tecnico}
                onChange={cambiar}
              >
                {Object.entries(DEPTO_LABELS).map(([valor, label]) => (
                  <option key={valor} value={valor}>{label}</option>
                ))}
              </CampoSelect>
            )}
          </div>

          <CampoSelect
            id="campo-estado"
            name="estado"
            label={t('perfilUsuario.estadoCuenta')}
            hint={t('perfilUsuario.hintSinVerificar')}
            value={form.estado}
            onChange={cambiar}
          >
            <option value="verificar">{t('perfilUsuario.verificarOpcion')}</option>
            <option value="verificado">{t('perfilUsuario.verificadoOpcion')}</option>
            <option value="suspendido">{t('perfilUsuario.suspendidoOpcion')}</option>
            {/* Se pone desde "dar de baja"; aquí sirve para revertirlo */}
            <option value="archivado">{t('usuarios.estados.archivado')}</option>
          </CampoSelect>
        </section>
      )}

      {/* Correos en copia: lo gestionan tanto técnicos como administradores */}
      <section className="pu-form-bloque">
        <h4 className="pu-form-seccion"><FiMail /> {t('perfilUsuario.notificaciones')}</h4>

        <CampoTexto
          id="campo-emails-cc"
          name="emails_cc"
          label={t('perfilUsuario.correosCopia')}
          hint={t('perfilUsuario.correosCopiaHint')}
          placeholder={t('perfilUsuario.correosCopiaPlaceholder')}
          value={form.emails_cc}
          onChange={cambiar}
          error={errorCorreosCc}
        />
      </section>

      {esAdmin && (
        <>
          <section className="pu-form-bloque">
            <h4 className="pu-form-seccion"><FiPackage /> {t('perfilUsuario.serviciosContratados')}</h4>

            <div className="pu-campo">
              <label id="label-servicios">{t('perfilUsuario.serviciosAsignados')}</label>
              <span className="pu-campo-hint">
                <Trans i18nKey="perfilUsuario.marcaServiciosHint">
                  Marca los servicios que tenga contratados el cliente. El catálogo se gestiona desde <Link to="/dashboard/gestion-servicios">Gestión → Servicios</Link>.
                </Trans>
              </span>

              {cargandoServicios ? (
                <p className="pu-srv-vacio">{t('perfilUsuario.cargandoCatalogo')}</p>
              ) : (
                <AsignadorServicios
                  catalogo={catalogoServicios}
                  seleccionados={serviciosAsignados}
                  onAlternar={onAlternarServicio}
                />
              )}
            </div>
          </section>

          <section className="pu-form-bloque">
            <h4 className="pu-form-seccion"><FiLock /> {t('perfilUsuario.seguridad')}</h4>

            <div className="pu-campo">
              <label>{t('perfilUsuario.contrasena')}</label>
              <span className="pu-campo-hint">
                {t('perfilUsuario.generarContrasenaHint')}
              </span>
              <button
                type="button"
                className="pu-btn-peligro"
                onClick={onResetearContrasena}
                disabled={reseteando}
              >
                <FiKey /> {reseteando ? t('perfilUsuario.reseteando') : t('perfilUsuario.resetearContrasena')}
              </button>
            </div>
          </section>

          {puedeDarDeBaja && (
            <section className="pu-form-bloque">
              <h4 className="pu-form-seccion pu-form-seccion--peligro"><FiAlertTriangle /> {t('perfilUsuario.zonaPeligro')}</h4>

              <div className="pu-campo">
                <label>{t('bajaUsuario.darDeBaja')}</label>
                <span className="pu-campo-hint">{t('bajaUsuario.darDeBajaHint')}</span>
                <button type="button" className="pu-btn-peligro" onClick={onDarDeBaja}>
                  <FiUserX /> {t('bajaUsuario.darDeBaja')}
                </button>
              </div>
            </section>
          )}
        </>
      )}
    </>
  );
};

export default FormularioAjustes;
